module.exports = __webpack_public_path__ + "img/sld_scb_5_green.726a067c.svg";